export const permissionRouteMap = {
  // Dashboard
  "dashboard": "dashboard",

  // Role + Staff
  "role": "roleManagement",
  "staff-management": "staffManagement",

  // USERS MODULE
  "users/user": "users.user",
  "users/traffic": "users.Traffic",
  "users/call-history": "users.CallHistory",
  "users/message-history": "users.MessageHistory",
  "users/coin-histories": "users.CoinHistory",
  "users/recharge": "users.Recharge",
  "users/avatar": "users.Avatar",
  "users/blockUser": "users.BlockUser",

  // PAYOUT
  "payout/kyc": "payout.kyc",
  "payout/approve": "payout.approve",
  "payout/wallet": "payout.wallet",
  "payout/manual-withdrawal": "payout.manualWithdrawal",

  // COIN MANAGEMENT
  "coin-management/manage-coins": "coinManagement.manageCoins",
  "coin-management/manage-gifts": "coinManagement.manageGifts",
  "coin-management/promocode": "coinManagement.promocode",
  "coin-management/promo-code-usage": "coinManagement.coinPromocode",

  // NOTIFICATIONS
  "notification/single": "Notifications.single",
  "notification/bulk": "Notifications.bulk",
  "notification/banner": "Notifications.banner",

  // USER REQUESTS
  "user-request/acc-delete-req": "userRequests.accDeleteReq",
  "user-request/group-request": "userRequests.groupReq",
  "user-request/name-change-req": "userRequests.nameChangeReq",

  // Feedback
  "contact-us": "appFeedback",
};
